export const getElementStyle = (className: string, property: string) => {
  const element = document.querySelector(`.${className}`) as HTMLElement;
  if (!element) return 0;
  return parseInt(window.getComputedStyle(element).getPropertyValue(property).split('px')[0]);
};
